import React from "react";
import { Provider } from "react-redux";
import store from "./store";
import { Routes, Route, HashRouter } from "react-router-dom";
import Header from "./components/header/header";
import Footer from "./components/footer/footer";
import FooterInfo from "./components/footer/footerInfo";
import Content from "./components/content/content";
import EjercicioInfo from "./components/content/ejercicio_info";
import Custom from "./components/custom_plan/custom";
import "./App.css";
import "toastr/build/toastr.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
// Import Swiper styles

import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import ReactGA from "react-ga";
function App() {
	ReactGA.initialize("UA-62287527-1");
	ReactGA.pageview("/ejercicios");
	return (
		<GoogleReCaptchaProvider
			reCaptchaKey='6Lc9X44UAAAAAOJ3ZnJSUQpiV7gfoTD-bsl4dyLl'
			useRecaptchaNet='true'
			language='es'
		>
			<Provider store={store}>
				<HashRouter>
					<Routes>
						<Route path={"/"} element={<Content />} />
						<Route path='ejercicio/:id' element={<EjercicioInfo />} />
						<Route exact path='personal_rutine/:id' element={<Custom />} />
					</Routes>
				</HashRouter>
			</Provider>
		</GoogleReCaptchaProvider>
	);
}

export default App;
